// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"9a17ad3f1d1a17cf5077","137":"910b8c834c293f03d3e1","138":"6b8d324ced83fc0e67d9","187":"697a13ee9cc3c4fc068b"}[chunkId] + ".chunk.js";
};